// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'auth.segurancaPage.title': 'Segurança da conta',
    'auth.segurancaPage.eyebrow': 'Perfil',
    'auth.segurancaPage.subtitle': 'Configure a verificação em duas etapas do seu acesso.',
  },
  en: {
    'auth.segurancaPage.title': 'Account security',
    'auth.segurancaPage.eyebrow': 'Profile',
    'auth.segurancaPage.subtitle': 'Set up two-step verification for your account.',
  },
  es: {
    'auth.segurancaPage.title': 'Seguridad de la cuenta',
    'auth.segurancaPage.eyebrow': 'Perfil',
    'auth.segurancaPage.subtitle': 'Configura la verificación en dos pasos de tu cuenta.',
  },
}
